import { Api } from '@blink/components';

export interface WalletEarningPerformance {
    apy: string;
    totalProfit: string;
}

export interface WalletEarning {
    performance: WalletEarningPerformance;
    poolAddress: string;
}

export type WalletEarningsResponse = WalletEarning[];

export const getWalletEarnings = ({
    walletAddress,
    pools,
    currency,
    from,
    to,
}: {
    walletAddress: string;
    pools?: string[];
    currency?: string;
    from?: string;
    to?: string;
}) => {
    const queryParams = new URLSearchParams({
        from: from ?? '2024-10-29T00:00:00Z',
        to: to ?? new Date().toISOString(),
    });

    if (pools?.length) {
        queryParams.append('pools', pools.join(','));
    }

    if (currency) {
        queryParams.append('currency', currency);
    }

    return Api.getResponse<WalletEarningsResponse>(
        `${Api.ARKIS_PORTAL_HTTP_URL}/v1/earnings/${walletAddress}?${queryParams.toString()}`,
    );
};
